import React, { Component } from "react";
import { GelDragDrop, UVTable, UVTransilluminator } from "@learningblocks/storybook-components";


import { toast } from 'react-toastify'
import "react-toastify/dist/ReactToastify.css"
import { css } from 'glamor'
import Toast from '../../../../toast/Toast'

import colors from "@learningblocks/protocol-constants/lib/Styles/_colors.scss"
import "./TransilluminatorControls.scss";
import { actualLaneData } from "./actualLaneData";


export class TransilluminatorControls extends Component {
  constructor(props) {
    super(props);

    this.state = {
      scale: 1,
      pressed: false,
    };
  }

//   componentDidUpdate(){
//       this.setState({
//           temp: this.props.temp,
//           time: this.props.time
//       })
//   }


  closeModal = () => {
    this.props.showModal({ display: false });
  };



  submitGelExamined(){
    this.props.transilluminatorGelExmined({ id: 1, gelExamined: true})
    this.closeModal();
  }
  
  turnOnTransilluminator = () =>{
    const { open, on, containsGel } = this.props
    if(open){
      this.makeToast("", "Due to safety hazard, you can not turn on the transilluminator while its open. Close the lid first.", "Transilluminator lid is open!")
      return
    }

    if(!open && !containsGel ){
      this.makeToast("", "Place gel in transilluminator first before turning on.", "Place gel in transilluminator!")
      return
    }

    this.props.turnOnTransilluminator({ id: 1, on: !on})
  }


  handleResize = () => {

    // let refSize = this.image.getBoundingClientRect();

    // let scale = Math.min(
    //   (refSize.width) / 162,
    //   (refSize.height) / 198
    // );

    // this.setState({
    //   scale: scale
    // })

  }
  // We need to attach a window event listener once the component is loaded in the DOM
  componentDidMount() {

    // Resize the scene and attach the resize method to the window resize event
    window.addEventListener("resize", this.handleResize)

  }
  componentWillUnmount(){

    window.removeEventListener("resize", this.handleResize)

  }
  componentDidUpdate(prevProps, prevState) {

    if(this.state.scale !== prevState.scale){
      this.handleResize()
    }
    if(this.props.display !== prevProps.display){
      this.handleResize()
    }
    if(this.props.notebookExpanded !== prevProps.notebookExpanded){
      this.handleResize()
    }

  }

  makeToast = (type, msg, title) => {
    let color = ""
    if(type==="HINT"){
      color = colors.yellow1
    } else {
      color = colors.red1
    }

    toast(<Toast type={type} msg={msg} title={title} />,{
      className: css({
        border: "2px solid "+color,
        borderRadius: "6px",
        marginLeft: "-200px",
        minWidth: "400px"
      }),
      progressClassName: css({
        background: color
      }),
      position: "top-center",
      autoClose: 5000,
    });
  }

   getActualGel = () => {
    const actualData = {
      "id": 3600,
      "type": "GEL_DRAG_DROP_QUESTION",
      "gelTheme": "DARK",
      "title":
        "Drag the DNA band on the gel below to the position you expect it to migrate through the gel.",
      "heading": "Predict the gel results:",
      "text":
        "With the knowledge of the size of the <i>TAS2R38</i> PCR product, where would you expect to see the band on the gel below? Use the DNA ladder, resolved alongside your sample, to judge the position of the band.",
      "gelRange": {
        "bottom": 80,
        "top": 1000
      },
      "content": ["dragdrop"],
      "gelTable": [
        {
          "colId": 0,
          "colType": "LABEL_COLUMN",
          "colItems": [
            {
              "cellId": 0,
              "cellType": "LABEL_CELL",
              "label": ""
            },
            {
              "cellId": 1,
              "cellType": "GEL_HOLDER",
              "cellItems": null,
              "label": "Base pairs (bp)"
            },
            {
              "cellId": 2,
              "cellType": "GEL_PATH",
              "cellItems": [
                {
                  "gelId": 0,
                  "gelType": "LABEL",
                  "height": 100,
                  "opacity": 1,
                  "value": 1000,
                  "selected": false
                },
                {
                  "gelId": 1,
                  "gelType": "LABEL",
                  "height": 100,
                  "opacity": 1,
                  "value": 800,
                  "selected": false
                },
                {
                  "gelId": 2,
                  "gelType": "LABEL",
                  "height": 100,
                  "opacity": 1,
                  "value": 700,
                  "selected": false
                },
                {
                  "gelId": 3,
                  "gelType": "LABEL",
                  "height": 100,
                  "opacity": 1,
                  "value": 500,
                  "selected": false
                },
                {
                  "gelId": 4,
                  "gelType": "LABEL",
                  "height": 100,
                  "opacity": 1,
                  "value": 400,
                  "selected": false
                },
                {
                  "gelId": 5,
                  "gelType": "LABEL",
                  "height": 100,
                  "opacity": 1,
                  "value": 300,
                  "selected": false
                },
                {
                  "gelId": 6,
                  "gelType": "LABEL",
                  "height": 100,
                  "opacity": 1,
                  "value": 200,
                  "selected": false
                },
                {
                  "gelId": 7,
                  "gelType": "LABEL",
                  "height": 100,
                  "opacity": 1,
                  "value": 100,
                  "selected": false
                }
              ]
            }
          ]
        }
      ]
    }
  
    //Add band items in the actual gel
    Object.keys(this.props.agaroseGel[0].lanes).forEach(
      (lane, index) => {
        if (true) {
          // if (gelExamined && gelOrientation === 180) {
          const solutionAlias = this.props.agaroseGel[0].lanes[lane].solutionAlias
          const level = this.props.level
  
          const laneData = actualLaneData(level, index, solutionAlias )
          actualData.gelTable.push(laneData)
       
      }
    }
    );
  
    return actualData.gelTable
  };

  render() {
    const gelTab = this.getActualGel()
    return (
      <>
      <div className="" style={{background: 'white' , height: "100%", width: "100%", overflow: "auto", paddingBottom: "2%"}}>
          <UVTransilluminator
            component={ ( <UVTable>
              <GelDragDrop
                theme='DARK'
                gelRange={{bottom: 100, top: 1000}}
                gelTable={gelTab}
              />
            </UVTable> )}
            title="Transilluminator Controls"
            onToggleSwitch = {()=>{this.turnOnTransilluminator()}}
            switchedOn={this.props.on}
            onSubmit = {()=>{this.submitGelExamined()}}
            closeB
            orientation={this.props.gelOrientation}
          />
        </div>
        </>
    );
  }
}